import { installComponents } from './components';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue, { primeOptions } from './prime';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import 'primeicons/primeicons.css';
import '@fontsource-variable/noto-sans-thai';
import App from './App.vue';
import router from './router';
import './assets/main.css';

const app = createApp(App);
app.use(createPinia());
app.use(PrimeVue, primeOptions);
app.use(ToastService);
app.use(ConfirmationService);
app.use(router);
installComponents(app);
app.mount('#app');
